import { render, staticRenderFns } from "./iconLabel.vue?vue&type=template&id=360c585e"
import script from "./iconLabel.vue?vue&type=script&lang=js"
export * from "./iconLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports